import { apolloClient } from '@/core/apollo/client';
import { GetUserDocument, UpdateUserDocument } from '@/core/graphql/types';
import { provideApolloClient, useQuery } from '@vue/apollo-composable';
import { computed } from 'vue';

export const useProfileApi = () => {
  // https://v4.apollo.vuejs.org/guide-composable/setup#usage-outside-of-setup
  const query = provideApolloClient(apolloClient)(() => useQuery(GetUserDocument));

  const user = computed(() => query.result.value?.me ?? null);

  const pushNotificationsToken = localStorage.getItem('pushNotificationsToken');

  provideApolloClient(apolloClient)(() => useQuery(
    UpdateUserDocument,
    () => ({
      input: {
        id: user.value!.id,
        fcmToken: pushNotificationsToken,
      },
    }),
    {
      enabled: Boolean(user.value?.id && !user.value?.fcmToken && pushNotificationsToken), // Запит буде виконаний, лише якщо умова є true
      // Якщо variables змінюється, а enabled залишається true, запит буде повторно виконаний
    },
  ));

  const getMe = async () => {
    const { data: { me } } = await apolloClient.query({
      query: GetUserDocument,
      variables: {
      },
    });

    return me;
  };

  return {
    user,
    getMe,
  };
};

// OLD code (temporary)
// export class UserApi {
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   private provideClient: <TFnResult = any>(fn: () => TFnResult) => TFnResult;

//   constructor() {
//     this.provideClient = provideApolloClient(apolloClient);
//   }

//   // https://v4.apollo.vuejs.org/guide-composable/setup#usage-outside-of-setup
//   async provideGetUser() {
//     const { data: { me } } = await this.provideClient(() => apolloClient.query({
//       query: GetUserDocument,
//       variables: {
//       },
//     }));

//     return me;
//   }
// }
